export default {
      id: "back-usage",
      viewBox: "0 0 7 12",
      url: __webpack_public_path__ + "img/icons.svg#back",
      toString: function () {
        return this.url;
      }
    }